function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M125.343 182.213C79.2499 182.213 41.752 144.981 41.752 99.2158C41.752 53.4508 79.2499 16.2188 125.343 16.2188C171.435 16.2188 208.934 53.4508 208.934 99.2158C208.934 144.981 171.435 182.213 125.343 182.213ZM125.343 27.2198C85.3159 27.2198 52.752 59.5168 52.752 99.2168C52.752 138.917 85.3149 171.214 125.343 171.214C165.369 171.214 197.934 138.917 197.934 99.2168C197.934 59.5168 165.37 27.2198 125.343 27.2198Z",
  fill: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M245.252 223.678C243.851 223.678 242.45 223.147 241.378 222.082L176.7 157.907C174.544 155.767 174.53 152.285 176.67 150.129C178.81 147.972 182.292 147.959 184.448 150.099L249.127 214.274C251.283 216.414 251.297 219.896 249.157 222.052C248.082 223.136 246.667 223.678 245.252 223.678Z",
  fill: "black"
});

function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.f508961616ee218f7d772e9df65510a7.svg";
export { ForwardRef as ReactComponent };